module.exports = __webpack_public_path__ + "img/onboarding_notification_pl.01c3acd4.png";